function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * @copyright Copyright (c) 2021 Louis Chemineau <louis@chmn.me>
 *
 * @author Louis Chemineau <louis@chmn.me>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
import Vue from 'vue';
import Vuex from 'vuex';
import { translate as t } from '@nextcloud/l10n';
import axios from '@nextcloud/axios';
import { generateUrl } from '@nextcloud/router';
import { loadState } from '@nextcloud/initial-state';
import { showSuccess, showError } from '@nextcloud/dialogs';
import '@nextcloud/dialogs/styles/toast.scss';
import { isActivityEnabled, isOneInputUnChecked } from './helpers/settings';
import logger from './logger';
Vue.use(Vuex);
/**
 * @typedef {Object} SettingsState
 * @property {Object} setting
 * @property {Object<string, ActivityGroup>} activityGroups
 * @property {boolean} isEmailSet
 * @property {boolean} emailEnabled
 * @property {boolean} activityDigestEnabled
 * @property {0|1|2|3} settingBatchtime
 * @property {Array<string>} methods
 * @property {string} endpoint
**/

var store = new Vuex.Store({
  strict: true,

  /** @type {SettingsState} */
  state: {
    setting: loadState('activity', 'setting'),
    activityGroups: loadState('activity', 'activity_groups'),
    isEmailSet: loadState('activity', 'is_email_set'),
    emailEnabled: loadState('activity', 'email_enabled'),
    activityDigestEnabled: loadState('activity', 'activity_digest_enabled', false),
    settingBatchtime: loadState('activity', 'setting_batchtime'),
    methods: loadState('activity', 'methods'),
    endpoint: ''
  },
  getters: {
    /**
     * Return an array of checked activities.
     *
     * @param {SettingsState} state - The current state.
     * @return {Array<string>}
     */
    checkedActivities: function checkedActivities(state) {
      var methodsEnabled = function methodsEnabled(activityKey, activity) {
        var methods = [];

        if (activity.email) {
          methods.push({
            activityKey: activityKey,
            method: 'email',
            activity: activity
          });
        }

        if (activity.notification) {
          methods.push({
            activityKey: activityKey,
            method: 'notification',
            activity: activity
          });
        }

        return methods;
      };

      return Object.values(state.activityGroups).map(function (group) {
        return Object.entries(group.activities);
      }) // [[[activityKey, activity], ...], [[activityKey, activity], ...]]
      .reduce(function (acc, val) {
        return acc.concat(val);
      }, []) // [[activityKey, activity], ...]
      .map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            activityKey = _ref2[0],
            activity = _ref2[1];

        return methodsEnabled(activityKey, activity);
      }) // [[{activityKey, method, activity}, ...], ...]
      .reduce(function (acc, val) {
        return acc.concat(val);
      }, []).filter(function (_ref3) {
        var activity = _ref3.activity,
            method = _ref3.method;
        return activity[method];
      }).map(function (_ref4) {
        var activityKey = _ref4.activityKey,
            method = _ref4.method;
        return "".concat(activityKey, "_").concat(method);
      }); // ['enabled_activity_key', ...]
    }
  },
  mutations: {
    /**
     * Update the 'enabled' state of a notification method for a given group/activity/method tuple
     *
     * @param {SettingsState} state - The current state.
     * @param {Object} payload - The payload.
     * @param {string} payload.groupKey - The targeted group
     * @param {string} payload.activityKey - The targeted activity
     * @param {string} payload.methodKey - The targeted method
     * @param {string} payload.value - The value to set
     */
    SET_METHOD_FOR_METHOD_AND_ACTIVITY: function SET_METHOD_FOR_METHOD_AND_ACTIVITY(state, _ref5) {
      var groupKey = _ref5.groupKey,
          activityKey = _ref5.activityKey,
          methodKey = _ref5.methodKey,
          value = _ref5.value;
      var group = state.activityGroups[groupKey];
      var activity = group.activities[activityKey];

      if (isActivityEnabled(activity, methodKey)) {
        activity[methodKey] = value;
      }
    },

    /**
     * Set the endpoint used to save the settings.
     *
     * @param {SettingsState} state - The current state.
     * @param {Object} payload - The payload.
     * @param {string} payload.endpoint - Where to POST the saveSettings request.
     */
    SET_ENDPOINT: function SET_ENDPOINT(state, _ref6) {
      var endpoint = _ref6.endpoint;
      state.endpoint = endpoint;
    },

    /**
     * Set the batch time.
     *
     * @param {SettingsState} state - The current state.
     * @param {Object} payload - The payload.
     * @param {0|1|2|3} payload.settingBatchtime - The selected batch time.
     */
    SET_SETTING_BATCHTIME: function SET_SETTING_BATCHTIME(state, _ref7) {
      var settingBatchtime = _ref7.settingBatchtime;
      state.settingBatchtime = settingBatchtime;
    },

    /**
     * Toggle activity digest.
     *
     * @param {SettingsState} state - The current state.
     * @param {Object} payload - The payload.
     * @param {boolean} payload.activityDigestEnabled - Enabled status of the activity digest.
     */
    TOGGLE_ACTIVITY_DIGEST: function TOGGLE_ACTIVITY_DIGEST(state, _ref8) {
      var activityDigestEnabled = _ref8.activityDigestEnabled;
      state.activityDigestEnabled = activityDigestEnabled;
    },

    /**
     * Toggle the availability of mail notifications
     *
     * @param {import('vuex').ActionContext<SettingsState, SettingsState>} store -
     * @param {Object} payload - The payload.
     * @param {boolean} payload.emailEnabled - Enabled status of the email notifications.
     */
    TOGGLE_EMAIL_ENABLED: function TOGGLE_EMAIL_ENABLED(state, _ref9) {
      var emailEnabled = _ref9.emailEnabled;
      state.emailEnabled = emailEnabled;
    }
  },
  actions: {
    /**
     * Set the endpoint used to save the settings.
     *
     * @param {import('vuex').ActionContext<SettingsState, SettingsState>} store -
     * @param {Object} payload - The payload.
     * @param {string} payload.endpoint - Where to POST the saveSettings request.
     */
    setEndpoint: function setEndpoint(_ref10, _ref11) {
      var commit = _ref10.commit;
      var endpoint = _ref11.endpoint;
      commit('SET_ENDPOINT', {
        endpoint: endpoint
      });
    },

    /**
     * Toggle the 'enabled' state of a notification method for a given group/activity/method tuple
     *
     * @param {import('vuex').ActionContext<SettingsState, SettingsState>} store -
     * @param {Object} payload - The payload.
     * @param {string} payload.groupKey - The targeted group
     * @param {string} payload.activityKey - The targeted activity
     * @param {string} payload.methodKey - The targeted method
     */
    toggleMethodForMethodAndActivity: function toggleMethodForMethodAndActivity(_ref12, _ref13) {
      var commit = _ref12.commit,
          state = _ref12.state,
          dispatch = _ref12.dispatch;
      var groupKey = _ref13.groupKey,
          activityKey = _ref13.activityKey,
          methodKey = _ref13.methodKey;
      var activity = state.activityGroups[groupKey].activities[activityKey];
      var oneInputIsChecked = isOneInputUnChecked([activity], methodKey);
      commit('SET_METHOD_FOR_METHOD_AND_ACTIVITY', {
        groupKey: groupKey,
        activityKey: activityKey,
        methodKey: methodKey,
        value: oneInputIsChecked
      });
      dispatch('saveSettings');
    },

    /**
     * Toggle the 'enabled' state of a notification method for a given group/method tuple
     *
     * @param {import('vuex').ActionContext<SettingsState, SettingsState>} store -
     * @param {Object} payload - The payload.
     * @param {string} payload.groupKey - The targeted group
     * @param {string} payload.methodKey - The targeted method
     */
    toggleMethodForGroup: function toggleMethodForGroup(_ref14, _ref15) {
      var commit = _ref14.commit,
          state = _ref14.state,
          dispatch = _ref14.dispatch;
      var groupKey = _ref15.groupKey,
          methodKey = _ref15.methodKey;
      var activities = Object.values(state.activityGroups[groupKey].activities);
      var oneInputIsChecked = isOneInputUnChecked(activities, methodKey);

      for (var activityKey in state.activityGroups[groupKey].activities) {
        commit('SET_METHOD_FOR_METHOD_AND_ACTIVITY', {
          groupKey: groupKey,
          activityKey: activityKey,
          methodKey: methodKey,
          value: oneInputIsChecked
        });
      }

      dispatch('saveSettings');
    },

    /**
     * Toggle the 'enabled' state of a notification method for a given group/activity tuple
     *
     * @param {import('vuex').ActionContext<SettingsState, SettingsState>} store -
     * @param {Object} payload - The payload.
     * @param {string} payload.groupKey - The targeted group
     * @param {string} payload.activityKey - The targeted activity
     */
    toggleMethodsForActivity: function toggleMethodsForActivity(_ref16, _ref17) {
      var commit = _ref16.commit,
          state = _ref16.state,
          dispatch = _ref16.dispatch;
      var groupKey = _ref17.groupKey,
          activityKey = _ref17.activityKey;
      var activity = state.activityGroups[groupKey].activities[activityKey];
      var oneInputIsChecked = activity.methods.map(function (method) {
        return isOneInputUnChecked([activity], method);
      }).includes(true);

      var _iterator = _createForOfIteratorHelper(activity.methods),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var methodKey = _step.value;
          commit('SET_METHOD_FOR_METHOD_AND_ACTIVITY', {
            groupKey: groupKey,
            activityKey: activityKey,
            methodKey: methodKey,
            value: oneInputIsChecked
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      dispatch('saveSettings');
    },

    /**
     * Set the batch time.
     *
     * @param {import('vuex').ActionContext<SettingsState, SettingsState>} store -
     * @param {Object} payload - The payload.
     * @param {0|1|2|3} payload.settingBatchtime - The selected batch time.
     */
    setSettingBatchtime: function setSettingBatchtime(_ref18, _ref19) {
      var commit = _ref18.commit,
          dispatch = _ref18.dispatch;
      var settingBatchtime = _ref19.settingBatchtime;
      commit('SET_SETTING_BATCHTIME', {
        settingBatchtime: settingBatchtime
      });
      dispatch('saveSettings');
    },

    /**
     * Toggle the activity digest.
     *
     * @param {import('vuex').ActionContext<SettingsState, SettingsState>} store -
     * @param {Object} payload - The payload.
     * @param {boolean} payload.activityDigestEnabled - Enabled status of the activity digest.
     */
    toggleActivityDigestEnabled: function toggleActivityDigestEnabled(_ref20, _ref21) {
      var commit = _ref20.commit,
          dispatch = _ref20.dispatch;
      var activityDigestEnabled = _ref21.activityDigestEnabled;
      commit('TOGGLE_ACTIVITY_DIGEST', {
        activityDigestEnabled: activityDigestEnabled
      });
      dispatch('saveSettings');
    },

    /**
     * Toggle the availability of mail notifications
     *
     * @param {import('vuex').ActionContext<SettingsState, SettingsState>} store -
     * @param {Object} payload - The payload.
     * @param {boolean} payload.emailEnabled - Enabled status of the email notifications.
     */
    toggleEmailEnabled: function toggleEmailEnabled(_ref22, _ref23) {
      var commit = _ref22.commit;
      var emailEnabled = _ref23.emailEnabled;
      commit('TOGGLE_EMAIL_ENABLED', {
        emailEnabled: emailEnabled
      });

      try {
        OCP.AppConfig.setValue('activity', 'enable_email', emailEnabled ? 'yes' : 'no');
        showSuccess(t('activity', 'Your settings have been updated.'));
      } catch (error) {
        showError(t('activity', 'Unable to save the settings'));
        logger.error('An error occurred while saving the activity settings', error);
      }
    },

    /**
     * Save the currently displayed settings
     * @param {import('vuex').ActionContext<SettingsState, SettingsState>} _ -
     */
    saveSettings: function saveSettings(_ref24) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var state, getters, form, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                state = _ref24.state, getters = _ref24.getters;
                _context.prev = 1;
                form = new FormData();
                getters.checkedActivities.forEach(function (activity) {
                  form.append(activity, '1');
                });
                form.append('notify_setting_batchtime', "".concat(state.settingBatchtime));
                form.append('activity_digest', "".concat(state.activityDigestEnabled ? 1 : 0));
                _context.next = 8;
                return axios.post(generateUrl(state.endpoint), form);

              case 8:
                response = _context.sent;
                showSuccess(response.data.data.message);
                _context.next = 16;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](1);
                showError(t('activity', 'Unable to save the settings'));
                logger.error('An error occurred while saving the activity settings', _context.t0);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 12]]);
      }))();
    }
  }
});
export default store;